import React, { useMemo } from 'react';
import { AppSkinProps } from '../../../types/decisions';
import Loading from '../../loading/Loading';
import AppResults from './AppResults/AppResults';
import { getCriteriaFieldsToDisplayInResults } from '../../../utils';

const AppProductResults = ({
    results,
    onRerank,
    onRerankMany,
    resultLoading,
    pageInfo,
    onPageChange,
    selectedProductIds,
    setSelectedProductIds,
    criteriaData,
    criteriaConstraints,
}: AppSkinProps) => {
    const displayFieldsIds: string[] = useMemo(() => {
        return getCriteriaFieldsToDisplayInResults(criteriaData.fields)
        .map(item => item.id);
    }, [ criteriaData.fields ]);

    return (
        <div className="application">
            <div className="application-details">
                <div/>
                <div className="app-results" style={{ width: '100%' }}>
                    {resultLoading ? (
                        <Loading/>
                    ) : (
                        <AppResults
                            results={results}
                            pageInfo={pageInfo}
                            onPageChange={onPageChange}
                            onRerank={onRerank}
                            onRerankMany={onRerankMany}
                            selectedProductIds={selectedProductIds}
                            setSelectedProductIds={setSelectedProductIds}
                            allowedFieldsIds={displayFieldsIds}
                            criteriaData={criteriaData}
                            criteriaConstraints={criteriaConstraints}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppProductResults;